var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"learning-paths"},_vm._l((_vm.primaryAreas.concat( _vm.secondaryAreas)),function(area){return _c('LearningPathsByLearningArea',{key:area.id,attrs:{"algoliaKeys":_vm.algoliaKeys,"area":area.name}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }